import { GridSortModel } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { EducationMaterialControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../utils/utils";

type EducationMaterialListProps = {
  pagination: DGT_Pagination;
  gridSorting: GridSortModel;
  status?: boolean;
  archive?: boolean;
  providerId?: string;
  specialityId?: string;
  searchString?: string;
  patientId?: string;
  xTENANTID?: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const useEducationMaterialList = (
  params: EducationMaterialListProps
): useBaseContent<any> => {
  const {
    pagination,
    gridSorting,
    status,
    archive,
    providerId,
    specialityId,
    searchString,
    patientId,
    xTENANTID,
  } = params;

  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: ["education-material-list", params],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new EducationMaterialControllerApi(
        xTENANTID ? getConfigObject() : undefined
      )
        .getAllEducationMaterials(
          pageIndex,
          pagination.pageSize, //size
          sortData?.field ?? undefined,
          sortData?.sort ?? undefined,
          status,
          archive,
          providerId,
          specialityId,
          searchString,
          patientId,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
